export default {
  FACEBOOK_APP_ID: '438652896632796',
  FACEBOOK_API_VERSION: 'v3.0',
  NAVER_CLIENT_ID: 'jFV818lFtt5R8zAR4TfW',
  KAKAO_CLIENT_ID: 'b58fde60f580b54daeb1e960b6a448b7',
};



// WEBPACK FOOTER //
// ./src/constants/social.js